import React from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import GridContainer from 'components/Grid/GridContainer';
import Divider from 'components/Tvendo/Common/Divider';
import GridItem from 'components/Grid/GridItem';
import PromotionRetentionLabels from './PromotionRetainedLabels';
import moment from 'moment';

export function RetentionDataGeneral(props) {
  const { retentionData, anotherData } = props;
  return (
    <CardContainer title="General" icon={null}>
      <GridContainer style={{ overflow: 'auto', maxHeight: '700px' }}>
        {Object.keys(PromotionRetentionLabels).map((key) => {
          let forceShow = PromotionRetentionLabels[key].forceShow;
          if (forceShow !== true && retentionData[key] === anotherData[key]) return undefined;

          let sameData = retentionData[key] === anotherData[key];

          let itemWidth = PromotionRetentionLabels[key].itemWidth;
          let label = PromotionRetentionLabels[key].label;
          let value = retentionData[key];
          switch (PromotionRetentionLabels[key].type) {
            case 'combo':
              value =
                PromotionRetentionLabels[key].values.find((option) => option.value === value)
                  ?.text || value;
              break;
            case 'number':
              value = parseFloat(value).toFixed(2);
              break;
            case 'date':
              value = moment(value).format('DD-MM-YYYY');
              break;
            case 'bool':
              if (PromotionRetentionLabels[key].parseChecked !== undefined) {
                value = PromotionRetentionLabels[key].parseChecked(value);
              }
              if (value === true) {
                value = 'Si';
              } else {
                value = 'No';
              }
              break;
          }

          return (
            <GridItem xl={3} {...itemWidth} key={key}>
              <h6 style={{ color: sameData ? undefined : 'red' }}>{label}</h6>
              <p>{value}</p>
            </GridItem>
          );
        })}
      </GridContainer>
    </CardContainer>
  );
}

export function RetentionDataRules(props) {
  const { retentionData, anotherData } = props;
  return (
    <CardContainer title={`Reglas: ${retentionData.rules.length}`} icon={null}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {retentionData.rules.map((rule, index) => {
          let anotherRule = anotherData.rules[index] || {};
          let cmr = rule.ehr;
          switch (rule.ehr) {
            case 'E':
              cmr = 'Cada';
              break;
            case 'H':
              cmr = 'Mayor';
              break;
            case 'R':
              cmr = 'Rango';
              break;
          }
          return (
            <div
              key={rule.id}
              style={{
                width: '100%',
                borderRadius: '10px',
                border: '2px solid black',
                padding: '5px 10px 0 10px',
              }}
            >
              {/* General */}
              <GridContainer>
                {/* Id */}
                <GridItem xs={12}>
                  <h6 style={{ color: rule.id !== anotherRule.id ? 'red' : undefined }}>Id</h6>
                  <p>
                    {rule.id}
                    {rule.description !== null && `: ${rule.description}`}
                  </p>
                </GridItem>
                {/* Cmr */}
                <GridItem xs={4}>
                  <h6 style={{ color: rule.ehr !== anotherRule.ehr ? 'red' : undefined }}>Cmr</h6>
                  <p>{cmr}</p>
                </GridItem>
                {/* Fecha Inicio */}
                <GridItem xs={4}>
                  <h6
                    style={{
                      color: rule.start_date !== anotherRule.start_date ? 'red' : undefined,
                    }}
                  >
                    Fecha Inicio
                  </h6>
                  <p>{rule.start_date}</p>
                </GridItem>
                {/* Fecha Fin */}
                <GridItem xs={4}>
                  <h6 style={{ color: rule.end_date !== anotherRule.end_date ? 'red' : undefined }}>
                    Fecha Fin
                  </h6>
                  <p>{rule.end_date}</p>
                </GridItem>
                {/* Prioridad */}
                <GridItem xs={3}>
                  <h6 style={{ color: rule.priority !== anotherRule.priority ? 'red' : undefined }}>
                    Prioridad
                  </h6>
                  <p>{rule.priority}</p>
                </GridItem>
                {/* Acumulado */}
                <GridItem xs={3}>
                  <h6
                    style={{
                      color: rule.cumulative !== anotherRule.cumulative ? 'red' : undefined,
                    }}
                  >
                    Acumulado
                  </h6>
                  <p>{rule.cumulative}</p>
                </GridItem>
                {/* Cantidad */}
                <GridItem xs={3}>
                  <h6 style={{ color: rule.qry_min !== anotherRule.qry_min ? 'red' : undefined }}>
                    Cantidad
                  </h6>
                  <p>{rule.qry_min}</p>
                </GridItem>
                <GridItem xs={3}>
                  <h6 style={{ color: rule.state !== anotherRule.state ? 'red' : undefined }}>
                    Estado
                  </h6>
                  <p>{rule.state === 'A' ? 'Activo' : 'Inactivo'}</p>
                </GridItem>
              </GridContainer>
              <Divider />
              {/* Grupos de venta */}
              {!!rule.product_groups && rule.product_groups.length > 0 && (
                <GridContainer>
                  <GridItem xs={12}>
                    <h6>Grupos de venta: {rule.product_groups.length}</h6>
                  </GridItem>
                  {rule.product_groups.map((group, index) => {
                    let anotherGroup = (anotherRule.product_groups || [])[index] || {};
                    return (
                      <GridItem xs={12} key={group.id}>
                        <GridContainer>
                          <GridItem xs={6}>
                            <h6
                              style={{
                                color: group.id !== anotherGroup.id ? 'red' : undefined,
                              }}
                            >
                              Id: {group.id}
                            </h6>
                          </GridItem>
                          <GridItem xs={6}>
                            <h6
                              style={{
                                color:
                                  group.products?.length !== anotherGroup.products?.length
                                    ? 'red'
                                    : undefined,
                              }}
                            >
                              Items: {group.products.length}
                            </h6>
                          </GridItem>
                          <GridItem xs={6}>
                            <h6
                              style={{
                                color:
                                  group.or_comparation !== anotherGroup?.or_comparation
                                    ? 'red'
                                    : undefined,
                              }}
                            >
                              Comparador O: {group.or_comparation === true ? 'Si' : 'No'}
                            </h6>
                          </GridItem>
                          <GridItem xs={12}>
                            <GridContainer>
                              {group.products.map((item, index) => {
                                let anotherItem = (anotherGroup.products || [])[index] || {};
                                return (
                                  <GridItem xl={12} key={item.id}>
                                    <h6
                                      style={{
                                        color:
                                          item.item_code !== anotherItem.item_code
                                            ? 'red'
                                            : undefined,
                                      }}
                                    >
                                      Código
                                    </h6>
                                    <p>{item.item.item_code}</p>
                                    <h6
                                      style={{
                                        color:
                                          item.item_description !== anotherItem.item_description
                                            ? 'red'
                                            : undefined,
                                      }}
                                    >
                                      Descripción
                                    </h6>
                                    <p>{item.item.item_description}</p>
                                  </GridItem>
                                );
                              })}
                            </GridContainer>
                          </GridItem>
                        </GridContainer>
                      </GridItem>
                    );
                  })}
                </GridContainer>
              )}
              <Divider />
              {/* Grupos de Bonificación */}
              {!!rule.bonification_groups && rule.bonification_groups.length > 0 && (
                <GridContainer>
                  <GridItem xs={12}>
                    <h6>Grupos de bonificación: {rule.bonification_groups.length}</h6>
                  </GridItem>
                  {rule.bonification_groups.map((group, index) => {
                    let anotherGroup = (anotherRule.bonification_groups || [])[index] || {};

                    return (
                      <GridItem xs={12} key={group.id}>
                        <GridContainer>
                          <GridItem xs={12}>
                            <h6
                              style={{
                                color: group.id !== anotherGroup.id ? 'red' : undefined,
                              }}
                            >
                              Id: {group.id}
                            </h6>
                            <h6
                              style={{
                                color:
                                  group.bonification_products.length !==
                                  anotherGroup.bonification_products?.length
                                    ? 'red'
                                    : undefined,
                              }}
                            >
                              Productos: {group.bonification_products.length}
                            </h6>
                          </GridItem>
                          <GridItem xs={12}>
                            <GridContainer>
                              {group.bonification_products.map((item, index) => {
                                let anotherItem =
                                  (anotherGroup.bonification_products || [])[index] || {};
                                return (
                                  <GridItem xl={12} key={item.id}>
                                    <h6
                                      style={{
                                        color:
                                          item.product?.ItemCode !== anotherItem.product?.ItemCode
                                            ? 'red'
                                            : undefined,
                                      }}
                                    >
                                      Código
                                    </h6>
                                    <p>{item.product.ItemCode}</p>
                                    <h6
                                      style={{
                                        color:
                                          item.product?.ItemName !== anotherItem.product?.ItemName
                                            ? 'red'
                                            : undefined,
                                      }}
                                    >
                                      Descripción
                                    </h6>
                                    <p>{item.product.ItemName}</p>
                                  </GridItem>
                                );
                              })}
                            </GridContainer>
                          </GridItem>
                        </GridContainer>
                      </GridItem>
                    );
                  })}
                  ;
                </GridContainer>
              )}
            </div>
          );
        })}
      </div>
    </CardContainer>
  );
}

export function RetentionDataRestrictions(props) {
  const { retentionData, anotherData } = props;
  return (
    <CardContainer title={`Restricciones Zonas: ${retentionData.restrictions.length}`} icon={null}>
      <GridContainer>
        {retentionData.restrictions.map((restriction, index) => {
          let anotherRestriction = (anotherData.restrictions || [])[index] || {};
          return (
            <GridItem key={restriction.id} xs={12}>
              <div
                key={restriction.id}
                style={{
                  width: '100%',
                  borderRadius: '10px',
                  border: '1px solid black',
                  padding: '5px 10px 0 10px',
                  marginBottom: '2px',
                }}
              >
                <GridContainer>
                  {/* Zona */}
                  <GridItem xs={3}>
                    <h6>Zona</h6>
                    <p>{restriction.zone.description}</p>
                  </GridItem>
                  {/* Canal */}
                  <GridItem xs={3}>
                    <h6>Canal</h6>
                    <p>{restriction.canal.description}</p>
                  </GridItem>
                  {/* Independiente */}
                  <GridItem xs={3}>
                    <h6
                      style={{
                        color:
                          restriction.independent !== anotherRestriction?.independent
                            ? 'red'
                            : undefined,
                      }}
                    >
                      Independiente
                    </h6>
                    <p>{restriction.independent === 'Y' ? 'Si' : 'No'}</p>
                  </GridItem>
                  {/* Estado */}
                  <GridItem xs={3}>
                    <h6
                      style={{
                        color: restriction.state !== anotherRestriction?.state ? 'red' : undefined,
                      }}
                    >
                      Estado
                    </h6>
                    <p>{restriction.state === 'A' ? 'Activo' : 'Inactivo'}</p>
                  </GridItem>
                  {/* Cantidad */}
                  <GridItem xs={4}>
                    <h6
                      style={{
                        color: restriction.limit !== anotherRestriction?.limit ? 'red' : undefined,
                      }}
                    >
                      Cantidad
                    </h6>
                    <p>{restriction.limit}</p>
                  </GridItem>
                  {/* Fecha Inicio */}
                  <GridItem xs={4}>
                    <h6
                      style={{
                        color:
                          restriction.start_date !== anotherRestriction?.start_date
                            ? 'red'
                            : undefined,
                      }}
                    >
                      F.Inicio
                    </h6>
                    <p>{restriction.start_date}</p>
                  </GridItem>
                  {/* Fecha Fin */}
                  <GridItem xs={4}>
                    <h6
                      style={{
                        color:
                          restriction.end_date !== anotherRestriction?.end_date ? 'red' : undefined,
                      }}
                    >
                      F.Fin
                    </h6>
                    <p>{restriction.end_date}</p>
                  </GridItem>
                </GridContainer>
              </div>
            </GridItem>
          );
        })}
      </GridContainer>
    </CardContainer>
  );
}

export function RetentionDataBureaus(props) {
  const { retentionData, anotherData } = props;
  return (
    <CardContainer title={`Mesas: ${retentionData.bureaus.length}`} icon={null}>
      <GridContainer>
        {retentionData.bureaus.map((bureau, index) => {
          let anotherBureau = (anotherData.bureaus || [])[index] || {};
          return (
            <GridItem key={bureau.id} xs={12}>
              <GridContainer>
                <GridItem xs={4}>
                  <h6>Zona</h6>
                  <p>{bureau.zone?.description}</p>
                </GridItem>
                <GridItem xs={4}>
                  <h6>Mesa</h6>
                  <p>{bureau.bureau?.description}</p>
                </GridItem>
                <GridItem xs={4}>
                  <h6
                    style={{
                      color: bureau.state !== anotherBureau.state ? 'red' : undefined,
                    }}
                  >
                    Estado
                  </h6>
                  <p>{bureau.state === 'A' ? 'Activo' : 'Inactivo'}</p>
                </GridItem>
              </GridContainer>
            </GridItem>
          );
        })}
      </GridContainer>
    </CardContainer>
  );
}
